export interface PatientConsentExtendedModel {
    patientId: number;
    consentId: number;
    consentStatus: ConsentStatusEnum;
    consentName: string;
    consentStatusName: string;
    changedDate: Date;
}

export enum ConsentStatusEnum {
    Unspecified = 0,
    Granted = 1,
    Denied = 2,
}

export interface PatientConsentCreateModel {
    consentId: number;
    consentStatus: ConsentStatusEnum;
}
